import React, { useEffect, useState } from "react";
import { T } from "react-translator-component";
import {
  Modal,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { colors } from "../../../common/colors";
import { styles } from "../../../pages/styles";
import SubmitButton from "../../SubmitButton";

// Define the props interface
interface DisclosureModalProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => any;
}

const DisclosureModal: React.FC<DisclosureModalProps> = ({
  open,
  onClose,
  onContinue,
}) => {
  const [isAgreed, setIsAgreed] = useState<boolean>(false);

  const handleAgreeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsAgreed(event.target.checked);
  };

  const handleContinue = async () => {
    if (isAgreed) {
      try {
        await onContinue();
        return true
      } catch {
        return false
      } finally {
        onClose();
      }
    } else {
      return false
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        style={{
          backgroundColor: colors.farm_gray15,
          paddingTop: 50,
          paddingLeft: "10px",
          paddingRight: "10px",
          height: "100%",
        }}
      >
      <Box
        style={{
          height: 300,
          width: "100%",
          borderColor: colors.farm_gray100,
          borderWidth: 2,
          borderRadius: 8,
          borderStyle: "solid",
          backgroundColor: "#FFFFFF",
          overflow: "hidden",
          padding: 10,
        }}
      >
        <iframe
          src="https://www.mebukupay.com/terms2"
          width="100%"
          height="100%"
          style={{ border: "none", marginTop: -100, overflowY: "auto", height: 400 }}
          title="Terms and Conditions"
        />
      </Box>
        <FormControlLabel
          control={<Checkbox checked={isAgreed} onChange={handleAgreeChange} />}
          label={T("agree_with_disclosure")}
        />
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <SubmitButton
            validate={async () => isAgreed}
            onSubmit={handleContinue}
            style={{
              ...styles.introSliderBtn,
              marginTop: 40,
              width: 220,
            }}
            size={"large"}
            variant="contained"
            endIcon={<ArrowForwardIosIcon />}
          >
            <span style={{ paddingRight: 30, paddingLeft: 40 }}>{T("next")}</span>
          </SubmitButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default DisclosureModal;
